<template>
  <div id="adTempBizMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>广告模板设置</el-breadcrumb-item>
          <el-breadcrumb-item>广告发布管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22">
        <el-form :inline="true"
                 class="pageSearch">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;"
                       @change="loadPark($event,false)">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       @change="loadChannel($event,false)"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通道::">
            <el-select v-model="pageSearch.fChnlID"
                       filterable
                       placeholder="请选择通道"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in channel_list"
                         :key="item.fChnlID"
                         :label="item.fChnlName"
                         :value="item.fChnlID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告模板::">
            <el-select v-model="pageSearch.fLcdTmpID"
                       filterable
                       placeholder="请选择广告模板"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in adTempList"
                         :key="item.fLcdTmpID"
                         :label="item.fGrpName"
                         :value="item.fLcdTmpID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       size="small"
                       @click="bindQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2"
              class="searchRowAdd">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-edit"
                   v-if="is_edit"
                   @click="handleAdd">新增广告发布
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="pageList"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fOpLastTime"
                         width="180"
                         label="最后操作时间">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                         label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkNo"
                         label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName"
                         label="场库名称">
        </el-table-column>
        <el-table-column prop="fChnlNo"
                         label="通道编号">
        </el-table-column>
        <el-table-column prop="fChnlName"
                         label="通道名称">
        </el-table-column>
        <el-table-column prop="fLcdTmpName"
                         label="模板名称">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="250">
          <template slot-scope="scope">
            <el-button @click="read(scope.row)"
                       type="success"
                       size="mini">查看</el-button>
            <el-button size="mini"
                       type="warning"
                       v-if="is_edit"
                       @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini"
                       type="danger"
                       v-if="is_del"
                       @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageSearch.pageIndex"
                         @current-change="handlePage"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="adTempBizDialog">
      <el-dialog :title=" dialogTitle"
                 :visible.sync="dialogVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="60%">
        <el-form :inline="true"
                 :rules="rules"
                 :model="form"
                 ref="ruleForm"
                 :disabled="!isEdit"
                 label-width="140px">
          <el-row>
            <el-form-item label="客户::"
                          prop="fCustID">
              <el-select v-model="form.fCustID"
                         filterable
                         placeholder="请选择客户"
                         style="width:200px;"
                         @change="loadPark($event,true)">
                <el-option v-for="item in cust_list"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库::"
                          prop="fParkID">
              <el-select v-model="form.fParkID"
                         filterable
                         placeholder="请选择场库"
                         style="width:200px;"
                         @change="loadChannel($event,true)">
                <el-option v-for="item in form_park_list"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="通道::"
                          prop="fChnlID">
              <el-select v-model="form.fChnlID"
                         filterable
                         placeholder="请选择通道"
                         style="width:200px;">
                <el-option v-for="item in form_channel_list"
                           :key="item.fChnlID"
                           :label="item.fChnlName"
                           :value="item.fChnlID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="广告模板::"
                          prop="fLcdTmpID">
              <el-select v-model="form.fLcdTmpID"
                         filterable
                         placeholder="请选择广告模板"
                         style="width:200px;"
                         clearable>
                <el-option v-for="item in adTempList"
                           :key="item.fLcdTmpID"
                           :label="item.fGrpName"
                           :value="item.fLcdTmpID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-form>
        <div class="dialog-footer">
          <el-button type="primary"
                     @click="submit('ruleForm')"
                     v-if="isEdit"
                     :loading="save_loading">{{save_msg}}</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as user from '../../api/user'
import * as park from '../../api/park'
export default {
  data () {
    return {
      pageSearch: {
        fCustID: '',
        fParkID: '',
        fChnlID: '',
        fLcdTmpID: '',
        pageSize: 20,
        pageIndex: 1
      },
      cust_list: [],
      park_list: [],
      form_park_list: [],
      channel_list: [],
      form_channel_list: [],
      adTempList: [],
      pageList: [],
      dialogVisible: false,
      save_loading: false,
      save_msg: '保存',
      loading: false,
      is_edit: false,
      is_del: false,
      isEdit: false,
      dialogTitle: '',
      form: {
        fAdPubID: '',
        fCustID: '',
        fParkID: '',
        fChnlID: '',
        fLcdTmpID: ''
      },
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fChnlID: [
          { required: true, message: '请选择通道', trigger: 'change' }
        ],
        fLcdTmpID: [
          { required: true, message: '请选择广告模板', trigger: 'change' }
        ]
      },
      tableHeight: 0,
      total: 0
    }
  },
  methods: {
    loadPark (fCustID, isForm) {
      if (isForm) {
        this.form.fParkID = ''
        this.form_park_list = []
        this.form.fChnlID = ''
        this.form_channel_list = []
      } else {
        this.pageSearch.fParkID = ''
        this.park_list = []
        this.pageSearch.fChnlID = ''
        this.channel_list = []
      }

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (isForm) {
              this.form_park_list = data.Data
            } else {
              this.park_list = data.Data
            }
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    loadChannel (fParkID, isForm) {
      if (isForm) {
        this.form.fChnlID = ''
        this.form_channel_list = []
      } else {
        this.pageSearch.fChnlID = ''
        this.channel_list = []
      }

      if (!fParkID) { return }
      // 加载通道
      park.channelList({ fParkID: fParkID, fCustID: isForm ? this.form.fCustID : this.pageSearch.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (isForm) {
              this.form_channel_list = data.Data
            } else {
              this.channel_list = data.Data
            }
          } else {
            this.$message.error('提示：加载通道列表失败')
          }
        }
      })
    },
    setDefault () {
      this.form = {
        fCustID: '',
        fParkID: '',
        fChnlID: '',
        fLcdTmpID: ''
      }
    },
    handleAdd () {
      this.setDefault()
      this.dialogVisible = true
      this.dialogTitle = '新增广告发布'
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
      })
      this.isEdit = true
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          park.saveAdTempBiz(this.form).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.initData()
                  this.dialogVisible = false
                  this.$message({
                    type: 'success',
                    message: data.Msg
                  })
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }
      })
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageSearch.pageIndex = index
      this.initData()
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    bindQuery () {
      this.initData()
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    view (row, isEdit) {
      this.setDefault()
      this.isEdit = isEdit
      // this.curRowInfo.op = op
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
      })
      this.form.fCustID = row.fCustID
      this.loadPark(row.fCustID, true)
      this.form.fParkID = row.fParkID
      this.loadChannel(row.fParkID, true)
      this.form.fChnlID = row.fChnlID
      this.form.fLcdTmpID = row.fLcdTmpID
      this.form.fAdPubID = row.fAdPubID
      this.dialogTitle = '【' + row.fLcdTmpName + '】' + (isEdit ? '编辑广告发布' : '查看广告发布')
      this.dialogVisible = true
    },
    read (row) {
      this.view(row, false)
    },
    edit (row) {
      this.view(row, true)
    },
    del (row) {
      this.$confirm('此操作将永久删除该广告发布[通道：' + row.fChnlName + '，模板：' + row.fLcdTmpName + '], 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        park.deleteAdTempBiz(row.fAdPubID).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.initData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    initData () {
      this.pageList = []
      this.loading = true
      park.getAdTempBizPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.pageList = data.Data.data || []
              this.total = data.Data.count
            }
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 1001000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  computed: {

  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.cust_list = data.Data
          if (this.cust_list && this.cust_list.length === 1) {
            this.pageSearch.fCustID = this.cust_list[0].fCustID
            this.loadPark(this.pageSearch.fCustID, false)
          }
        } else {
          this.$message.error('提示：加载客户列表失败')
        }
      }
    })
    park.getAdTempList().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.adTempList = data.Data
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
.adTempBizDialog .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.adTempBizDialog
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.adTempBizDialog .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.adTempBizDialog .el-dialog__title {
  color: white;
}
.adTempBizDialog .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
/* .adTempDialog .el-dialog__body {
  padding: 0px;
} */
.adTempBizDialog .myParkInput {
  width: 220px;
}
.adTempBizDialog .el-row {
  margin-bottom: 20px;
}
.adTempBizDialog fieldset .el-row {
  margin-bottom: 0px;
}
.adTempBizDialog .el-radio {
  line-height: 2px;
}
.adTempBizDialog .is-disabled .el-input__inner,
.adTempDiadTempBizDialogalog .is-disabled .el-textarea__inner {
  color: #606266;
}
.adTempBizDialog .fRemark_row .el-form-item__content {
  height: 60px !important;
}
.adTempBizDialog .parkTextArea .el-textarea__inner {
  width: 800px;
  height: 60px !important;
}
.adTempBizDialog .imgDialog .el-dialog__body {
  text-align: center;
  overflow: hidden;
}
</style>
<style scoped>
.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}
#parkBaiduMap {
  float: left;
}
.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}
.search_list {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  float: left;
}
.search_list .el-row {
  margin-top: 0px;
}
.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}
.parkMain_BaseInfo .el-select {
  width: 100%;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
/* legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
} */
fieldset {
  /* margin: 0 2px; */
  border: 1px solid silver;
}
.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
.tab_foot {
  float: left;
  width: 110px;
  height: 80px;
  background: #ccc;
}
.btn_foot {
  float: left;
  text-align: right;
  padding: 20px;
}
.dialog-footer {
  text-align: right;
  padding: 20px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/park/adTempBizMain.vue